import { z } from 'zod';

export const schema = z.object({
	id: z.string(),
	documentId: z.string(),
	name: z.string(),
	content: z.string().min(20, 'Please enter at least 20 characters to help us understand better.'),
	threadOf: z.number().optional()
});
